import { render, staticRenderFns } from "./PlatformIntroduction.vue?vue&type=template&id=75f3d3c8&"
import script from "./PlatformIntroduction.vue?vue&type=script&lang=js&"
export * from "./PlatformIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./PlatformIntroduction.vue?vue&type=style&index=0&id=75f3d3c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports